import { isFunction } from "lodash";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useLoanFilesHook } from "../../hooks/useLoanFilesHook";
import { loanDrilldownSet } from "../../redux/actions/loanDrilldownActions";
import FileUploadProcess from "./FileUploadProcess";

const LoanBorrowerFileUploadProcess = ({
  loanId,
  borrowerId,
  docType,
  docGroup,
  showDivider = true,
  keyName,
  onProcessComplete,
  hideCategoryAndTypeSelection = false,
  perFileDocType = false,
}) => {
  const { uploadLoanDocsWithAssociations } = useLoanFilesHook();
  const dispatch = useDispatch();

  const [isProcessing, setIsProcessing] = useState(false);

  const handleOnSubmit = useCallback(
    (f, { onSuccessFn } = {}) => {
      if (!loanId) return;

      setIsProcessing(true);

      uploadLoanDocsWithAssociations({
        loanId,
        files: f,
        borrowerIds: borrowerId ? [borrowerId] : undefined,
        onSuccessFn: (d) => {
          dispatch(loanDrilldownSet(d));
          setIsProcessing(false);
          onSuccessFn?.();
          if (isFunction(onProcessComplete)) onProcessComplete();
        },
        onFailFn: () => {
          setIsProcessing(false);
        },
      });
    },
    [
      loanId,
      borrowerId,
      uploadLoanDocsWithAssociations,
      dispatch,
      onProcessComplete,
    ],
  );

  return (
    <FileUploadProcess
      loanId={loanId}
      docType={docType}
      borderSize={2}
      docGroup={docGroup}
      keyName={keyName}
      onSubmit={handleOnSubmit}
      loading={isProcessing}
      showDivider={showDivider}
      allowedDocGroups={BORROWER_DOC_GROUPS}
      hideCategoryAndTypeSelection={hideCategoryAndTypeSelection}
      perFileDocType={perFileDocType}
    />
  );
};

const BORROWER_DOC_GROUPS = [
  "Borrower Documents",
  "Borrower Reports",
  "Experience and Track Record",
  "Liquidity",
  "Related Entity Docs",
];

export default LoanBorrowerFileUploadProcess;
